module.exports = __webpack_public_path__ + "img/set_up.544bc555.svg";